import axios from 'axios'
import store from '@/store'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

service.interceptors.request.use(config => {
  if (store.state.token) config.headers.Token = store.state.token
  config.data = JSON.stringify(config.data)
  return config
}, error => {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const { response } = error
    return response ? response.data : Promise.reject(error)
  }
)


// axios.defaults.withCredentials = true
const openApi = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
      'AppKey': process.env.VUE_APP_API_KEY,
      "Content-Type": "application/json"
    }
})

openApi.interceptors.request.use(config => {
  if (store.state.token) config.headers.Token = store.state.token
  config.data = JSON.stringify(config.data)

  return config
}, error => {
  return Promise.reject(error)
})
  
// response interceptor
openApi.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const { response } = error
    return response ? response.data : Promise.reject(error)
  }
)

export { service, openApi }
